if (typeof JW === 'undefined') JW = {};
JW.Mapwidget = function ($, mw, oo)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'MAPWIDGET';
    _pri.opts = {                               // options for various object initializations
        atk:            '',
        form_id:        '',
        static:         true,
        resize_center:  true
    };

    _pri.inited          = false;
    _pri.page            = null;

    _pri.mid =          'jobery.2658d8fe';      // mapbox map variant id
    _pri.mb_style_url = 'mapbox://styles/jobery/ciqmxpdk8001mc0m74y6uw1ig';
    _pri.map_format   = '.png32';               // mapbox map format: jpg70 jpg80 ... (with dot! because you may want to prefix for mat with @2x i.e. @2x.png)
    _pri.map_hdpi     = '';                     // fill with @2x for high dpi devices

    _pri.$map            = $(mw);               // div
    _pri.map             = null;                // L.map obj
    _pri.tile_layer      = null;                // map tiles

    _pri.$cont           = null;                // surrounding div
    _pri.location_marker = null;
    _pri.mwpu            = null;                // start up popup
    _pri.mwcnf           = null;                // start up config instead of mwpu
    _pri.ll_center       = [51.309155, 10.217285];

    _pri.rid = 0;                               // request id (ll.toString() - should be sufficient as long as no common event marker has been introduced ...)
    _pri.pid = 0;                               // widget public id

    _pri.mode = 0;                              // 0: static, don't move marker | 1: interactive
    _pri.click_mode = 1;                        // 0: don't move marker on click | 1: move


    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        _pri.dbgG('*** init()');

        if (_pri.inited)
        {
            _pri.dbg('!!! already inited!');
            return;
        }

        _pri.inited = true;
        _pri.page   = JW.Page;
        _pri.pid    = _pri.page.getUId(32);

        if (_pri.$map.length == 0)
        {
            _pri.dbg('    no #map - exit');
            _pri.$map = null;
            return;
        }

        if (typeof window.devicePixelRatio !== 'undefined' && window.devicePixelRatio > 1.5)
        {
            _pri.map_hdpi = '@2x';
        }

        _pri.initOpts();
        _pri.$cont = _pri.$map.closest('div');
        _pri.parseData();
        _pri.initMap();
    };

    _pri.parseData = function()
    {
        _pri.dbgG('*** parseData()');

        var mwpu = _pri.$map.data('mwpu');
        let cnf  = _pri.$map.data('cnf');
        if (typeof mwpu !== 'undefined' && '' != mwpu)
        {
            _pri.dbg('    data(\'mwpu\') found ... mwpu:', mwpu);
            _pri.mode = 0;

            var $mwpu = $(mwpu).remove();
            if ($mwpu.length > 0)
            {
                var llstr = $mwpu.data('ll');
                if (typeof llstr !== undefined && '' != llstr)
                {
                    var ll = llstr.split(',');
                    if (2 == ll.length && ll[0] > 0.1)
                    {
                        $mwpu.removeClass('d-none');
                        _pri.mwpu = {html: $mwpu[0], ll: ll};
                        _pri.ll_center = ll;
                    }
                }
            }
        }
        else if (_pri.isObj(cnf))
        {
            _pri.dbg('    cnf given ...');
            _pri.mwcnf =
            {
                ll: null,
                title: ''
            };

            if (typeof cnf.mode === 'number' && (cnf.mode == 1 || cnf.mode == 0))
            {
                _pri.mode = cnf.mode;
            }

            if (typeof cnf.click_mode === 'number' && (cnf.click_mode == 1 || cnf.click_mode == 0))
            {
                _pri.click_mode = cnf.click_mode;
            }

            if (typeof cnf.zoom === 'number' && (cnf.zoom >= 3 || cnf.zoom <= 17))
            {
                _pri.opts.map.zoom = cnf.zoom;
            }

            if (typeof cnf.contextmenu === 'boolean')
            {
                _pri.opts.map.contextmenu = cnf.contextmenu;
            }

            if (typeof cnf.title === 'string' && cnf.title != '')
            {
                _pri.mwcnf.title = cnf.title;
            }

            if (_pri.isObj(cnf.ll) && Array.isArray(cnf.ll) && cnf.ll.length == 2)
            {
                _pri.dbg('    ll given:', cnf.ll);
                _pri.mwcnf.ll = L.latLng(cnf.ll[0], cnf.ll[1]);

            }
            else
            {
                _pri.dbgR('    no ll given ...?');
            }
        }
        else
        {
            _pri.mode = 1;
            _pri.initLocationMarker();
        }

        // TODO set data to enable ...
        // parse data for location markers ...
        // _pri.opts.static = false;
        // _pri.initLocationMarker();
        // ...

    };

    _pri.initMap = function()
    {
        _pri.dbgG('*** initMap()');

        //_pri.tile_layer = L.tileLayer('https://{s}.tiles.mapbox.com/v4/' + _pri.mid + '/{z}/{x}/{y}' + _pri.map_hdpi + _pri.map_format + '?access_token=' + _pri.opts.atk, _pri.opts.tile_layer);
        _pri.tile_layer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + _pri.opts.atk, _pri.opts.tile_layer);
        // _pri.tile_layer.addTo(_pri.map);

        _pri.opts.map.layers = [_pri.tile_layer];

        if (_pri.mode === 0)
        {
            _pri.opts.map.contextmenuItems.shift();
        }

        _pri.map = L.map(_pri.$map[0], _pri.opts.map);

        L.control.zoom(_pri.opts.control_zoom).addTo(_pri.map);
        L.control.fullscreen(_pri.opts.control_fullscreen).addTo(_pri.map);
        L.Control.scaleDl(_pri.opts.control_scale).addTo(_pri.map);
        // L.control.coordinates(_pri.opts.control_coordinates).addTo(_pri.map);

        if (_pri.mode === 1)
        {
            // events geoc

            _pri.page.on('geoc:get_ll_to_address_done', function(e, o) {
                _pri.dbg('on geoc:get_ll_to_address_done', o);

                if (o.addr.form_id == _pri.opts.form_id)
                {
                    _pri.setMarkerLL(o.ll);
                }
            });
        }

        _pri.map.on('fullscreenchange', _pri.fullscreenChange);
        _pri.map.on('click', _pri.mapClick);
        _pri.map.on('resize', _pri.mapResize);
        _pri.map.on('focus', _pri.mapFocus);
        _pri.map.on('load', _pri.mapLoaded);

        //_pri.map.on('moveend', _pri.onMoveEnd);
        // _pri.map.on('zoomend', function(e){
        //     _pri.dbg('zoomend', _pri.map.getZoom());
        // });

        if (_pri.mode === 0)
        {
            _pri.map.scrollWheelZoom.disable();
        }

        _pri.map.on('focus', _pri.mapFocus);
        _pri.map.on('blur', _pri.mapBlur);

        _pri.map.setView(_pri.ll_center, _pri.opts.map.zoom);
    };

    _pri.mapLoaded = function()
    {
        _pri.dbgG('*** mapLoaded()');

        if (typeof _pri.mwpu === 'object' && _pri.mwpu != null)
        {
            _pri.dbg('    mwpu found ...');

            var popup = L.popup({closeButton: false, closeOnClick: false})
                .setLatLng(_pri.mwpu.ll)
                .setContent(_pri.mwpu.html)
                .openOn(_pri.map);
            // _pri.map.panTo(ll);
            var px = _pri.map.project(_pri.mwpu.ll);    // find the pixel location on the map where the popup anchor is
            px.y -= popup._container.clientHeight / 2;  // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
            _pri.ll_center = _pri.map.unproject(px);
            _pri.dbg('ll_center: ', _pri.ll_center);
            _pri.map.panTo(_pri.ll_center);             // pan to new center
        }
        else if (_pri.isObj(_pri.mwcnf) && _pri.isObj(_pri.mwcnf.ll))
        {
            var icon = new TopMarker({
                html: '<b>&nbsp;</b>'
            });

            _pri.location_marker = new L.marker(_pri.mwcnf.ll, {icon: icon, title: _pri.mwcnf.title, draggable: false});

            if (_pri.mwcnf.title != '')
            {
                // let title = '<b>Messe-Veranstaltungsort</b><br>xxxxx ........';
                _pri.location_marker.bindPopup(_pri.mwcnf.title);
            }

            _pri.ll_center = _pri.mwcnf.ll;
            _pri.setMarkerLL(_pri.mwcnf.ll, 11);
            // _pri.dbg('zoom:', _pri.map.getZoom());
            _pri.map.panTo(_pri.ll_center);
            // setTimeout(() => {
            //     _pri.dbg('0 zoom:', _pri.map.getZoom());
            //     _pri.map.setZoom(11);
            //     _pri.dbg('1 zoom:', _pri.map.getZoom());
            // }, 1000);
        }
    }

    publ.getPid = function()
    {
        return _pri.pid;
    };

    publ.getRid = function()
    {
        return _pri.rid;
    };

    publ.hideMarker = function()
    {
        if (_pri.map.hasLayer(_pri.location_marker))
        {
            _pri.map.removeLayer(_pri.location_marker);
        }
    };

    _pri.getAddressToLL = function(ll)
    {
        _pri.rid = ll.toString();
        JW.GeoC.getAddressToLL(ll);
    };

// ################################################################
// ################################################################
//         Location Marker
// ################################################################
// ################################################################

    _pri.fullscreenChange = function(e)
    {
        if (_pri.map.isFullscreen())
        {
            _pri.page.suspendResize(true);
        }
        else
        {
            _pri.page.suspendResize(false);
            // _pri.page.resize();
        }
    };

    _pri.mapClick = function(e)
    {
        _pri.dbg('********* mapClick()');

        if (_pri.click_mode == 1 && _pri.location_marker != null)
        {
            var ll = e.latlng;
            _pri.location_marker.setLatLng(ll);
            if (!_pri.map.hasLayer(_pri.location_marker))
            {
                _pri.location_marker.addTo(_pri.map);
            }

            _pri.getAddressToLL(ll);
        }
    };

    _pri.mapFocus = function(e)
    {
        _pri.dbg('********* mapFocus()');
        _pri.map.scrollWheelZoom.enable();
    };

    _pri.mapBlur = function(e)
    {
        _pri.dbg('********* mapBlur()');
        _pri.map.scrollWheelZoom.disable();
    };

    _pri.setMarkerLL = function(ll, zoom)
    {
        if (typeof zoom === 'undefined')
        {
            zoom = 16;
        }
        _pri.location_marker.setLatLng(ll);
        if (!_pri.map.hasLayer(_pri.location_marker))
        {
            _pri.location_marker.addTo(_pri.map);
        }

        setTimeout(function() {
            _pri.map.setView(ll, zoom);
        }, 400);
    };

    _pri.initLocationMarker = function()
    {
        _pri.dbg('********* initLocationMarker()');
        var ll = L.latLng(51.309155, 10.217285);
        var icon = new HomeMarker({
            html: '<b>&nbsp;</b>'
        });
        var title = '<b>Standort</b><br>Ziehen Sie diesen auf die gewünschte Position, oder Klicken Sie in der Karte auf den entsprechenden Punkt.';

        _pri.location_marker = new L.marker(ll, {icon: icon, title: title, draggable: true});
        _pri.location_marker.bindPopup(title);
        //_pri.location_marker.setZIndexOffset(100000);
        _pri.location_marker.on('dragend', function(e) {
            var cll = _pri.location_marker.getLatLng();
            _pri.dbg('*** drag end to:', cll);
            _pri.getAddressToLL(cll);
        });

        // var popup = L.popup({closeButton: false, closeOnClick: false})
        //     .setLatLng([51.5, -0.09])
        //     .setContent("I am a standalone popup.")
        //     .openOn(_pri.map);
    };

    _pri.mapResize = function(e)
    {
        _pri.dbg('******** mapResize()');
        if (_pri.opts.resize_center)
        {
            _pri.dbg('         calling invalidate in 400 ms ... ');
            setTimeout(function(){
                _pri.map.invalidateSize();
                if (_pri.mode === 0)
                {
                    _pri.map.panTo(_pri.ll_center);
                }
                else
                {
                    _pri.map.panTo(_pri.location_marker.getLatLng());
                }
            }, 400);
        }
    };

// ################################################################
// ################################################################
//         Context Menu
// ################################################################
// ################################################################


    _pri.cmShowCoordinates = function(e)
    {
        alert(e.latlng);
    };

    _pri.cmSetHere = function(e)
    {
        _pri.mapClick(e);
    };

    _pri.cmZoomIn = function(e) {
        _pri.map.zoomIn();
    };

    _pri.cmZoomOut = function(e) {
        _pri.map.zoomOut();
    };



    _pri.initOpts = function()
    {
        // _pri.dbgG('*** initOpts() oo: ', oo);

        var opts = {
            map: {
                zoom: 12,
                minZoom: 3,
                maxZoom: 17,
                attributionControl: false,
                contextmenu: true,
                //contextmenuWidth: 140,
                contextmenuItems: [
                    {
                        text: '<i class="fa fa-search fa-fw" aria-hidden="true"></i> Als Adresse setzen',
                        callback: _pri.cmSetHere
                    },
                    {
                        text: '<i class="fa fa-map-marker fa-fw" aria-hidden="true"></i> Koordinaten anzeigen',
                        callback: _pri.cmShowCoordinates
                    },
                    '-',
                    {
                        text: '<i class="fa fa-search-plus fa-fw" aria-hidden="true"></i> Ansicht vergrößern',
                        callback: _pri.cmZoomIn
                    },
                    {
                        text: '<i class="fa fa-search-minus fa-fw" aria-hidden="true"></i> Ansicht verkleinern',
                        callback: _pri.cmZoomOut
                    }
                ],
                maxBounds: [
                    [-90, -Infinity],
                    [90, Infinity]
                ],
                zoomControl: false,
                fullscreenControl: false
            },
            tile_layer: {
                // +++ new
                    // id: 'mapbox/streets-v11',
                    // id: 'jobery/ciqmxpdk8001mc0m74y6uw1ig',
                    // id:         'jobery/ckcp6y5lw06h21il9a6vc8mcl', // JW
                    id:         'jobery/ckcphzem80h0j1iqpndizd38v', // JW-bright
                    tileSize:   512,
                    zoomOffset: -1,
                // ---
                subdomains: 'abcd'
            },
            control_zoom: {
                position: 'topleft',
                zoomInText: '',
                zoomOutText: '',
                zoomInTitle: 'Vergrößern',
                zoomOutTitle: 'Verkleinern'
            },
            control_fullscreen: {
                position: 'topleft'
            },
            control_scale: {
                imperial: false,
                maxWidth: 120
            },
            control_coordinates: {
                position: "bottomleft", //optional default "bootomright"
                decimals: 5, //optional default 4
                decimalSeperator: ".", //optional default "."
                labelTemplateLat: "Latitude: {y}", //optional default "Lat: {y}"
                labelTemplateLng: "Longitude: {x}", //optional default "Lng: {x}"
                enableUserInput: true, //optional default true
                useDMS: false, //optional default false
                useLatLngOrder: true, //ordering of labels, default false-> lng-lat
                markerType: L.marker, //optional default L.marker
                markerProps: {} //optional default {},
                //labelFormatterLng: function(lng){return lng+" lng"}, //optional default none,
                //labelFormatterLat: function(lat){return lat+" lat"}, //optional default none
                // customLabelFcn: function(latLonObj, opts) { "Geohash: " + encodeGeoHash(latLonObj.lat, latLonObj.lng)} //optional default none
            }
        };

        if ($('body').data('fsps'))
        {
            opts.control_fullscreen.pseudoFullscreen = true;
        }
        // else
        // {
        //     opts.control_fullscreen.pseudoFullscreen = true;
        // }

        $.extend(_pri.opts, opts);
        if (typeof oo === 'object')
        {
            $.extend(_pri.opts, oo);
        }
        _pri.opts.atk = JW.Page.getATk();
    };

// ################################################################
// ################################################################
//         Utils & Misc
// ################################################################
// ################################################################

    publ.tests = function()
    {

    };

    publ.getMapCenter = function()
    {
        if (!_pri.map)
        {
            return null;
        }
        return _pri.map.getCenter();
    }

    _pri.extend();
    _pri.init();
    // expose public methods
    return publ;
};
